import { render, staticRenderFns } from "./AvvisoMenu.vue?vue&type=template&id=40db9a62&scoped=true&"
import script from "./AvvisoMenu.vue?vue&type=script&lang=js&"
export * from "./AvvisoMenu.vue?vue&type=script&lang=js&"
import style0 from "./AvvisoMenu.vue?vue&type=style&index=0&id=40db9a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db9a62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VForm,VIcon,VLayout,VListTileAvatar,VSpacer,VTextarea,VTooltip})
